<template>
  <div>
    <!-- 저장하기 버튼 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="save">저장하기</button>
    </div>
    <div class="columns is-multiline">

      <div class="column is-half-desktop is-full-tablet">
        <!-- 서비스 기본 정보 -->
        <div class="box">
          <admin-box-item title="서비스 공통 설정" subtitle="상품 등록시 기본으로 사용할 상품 종류를 선택합니다.">
            <!-- 기본 상품 종류 -->
            <div class="column is-full">
              <admin-form-item label="기본 상품 종류 선택">
                <div style="padding-top: 8px">
                  <span v-for="pack in packages" :key="'package-'+pack.id">
                    <div class="pack-box"
                         @click="selectPackage(pack)"
                         :class="{'package-selected':pack.name===basic_package}">{{ pack.kor_name }}</div>
                  </span>
                </div>
              </admin-form-item>
            </div>
          </admin-box-item>

        </div>
      </div>
      <!-- 기본 상품 종류 -->
      <div class="column is-half" v-if="showPayTypeSetting">
        <div class="box position-relative">
          <div class="dim" v-if="isCall">*결제 기능을 제공하지 않는 팩입니다.</div>
          <admin-box-item title="결제 방식 설정">
            <!-- 기본 결제 방식 -->
            <admin-form-item :label="basicPay.label">
              <div v-for="(item, idx) in basicPay.pay_type" style="margin-bottom: 8px" :key="`item-${idx}`">
                <div>
                  <lp-check-bool v-if="item.isUsable" :checkedVal.sync="item.enable"
                                 :key="`pay-type-${idx}`"
                                 :label="item.label"></lp-check-bool>
                  <lp-add-pay-type v-else :key="`pay-type-${idx}`"
                                   :label="item.label" :item="item"></lp-add-pay-type>
                  <div v-if="item.name==='nobank'"
                       style="padding-top:8px">
                    <div style="background-color:#E9E9E9;padding:12px 9px" v-if="item.enable">
                      <div class="size-13 weight-700">입금 계좌 정보</div>
                      <div style="padding-top:8px">
                        <div class="size-13" style="margin-bottom: 4px">은행</div>
                        <span class="select" style="width:calc(50% - 6px)">
                          <select v-model="orderSetting.bank.bank" style="width:100%"
                                  @change="e=> orderSetting.bank.bank = e.target.value">
                            <option value="" disabled selected>은행 선택</option>
                            <option v-for="(bank,idx) in bankArr" :key="'bank-'+idx">{{ bank.label }}</option>
                          </select>
                        </span>
                      </div>

                      <div class="flex-align" style="padding-top:8px;gap:12px">
                        <div style="flex:1">
                          <div class="size-13" style="margin-bottom: 4px">계좌번호</div>
                          <input class="input"
                                 :value="orderSetting.bank.account_num"
                                 @input="e=> orderSetting.bank.account_num = e.target.value"
                                 placeholder="계좌번호를 입력하세요."
                                 type="text">
                        </div>
                        <div style="flex:1">
                          <div class="size-13" style="margin-bottom: 4px">예금주</div>
                          <input class="input"
                                 :value="orderSetting.bank.name"
                                 @input="e=> orderSetting.bank.name = e.target.value"
                                 placeholder="예금주를 입력하세요."
                                 type="text">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </admin-form-item>

            <!-- PG, 간편결제 -->
            <div class="position-relative">
              <template v-for="(pay, p_idx) in payList">
                <admin-form-item :label="pay.label" v-if="pay.pay_type.length>0" :key="`pay-${p_idx}`"
                                 :customHeaderStyle="{justifyContent: 'space-between', alignItems: 'center'}">
                  <div v-for="(item, idx) in pay.pay_type" style="margin-bottom: 8px" :key="`item-${idx}`">

                    <div>
                      <div v-if="item.isUsable" class="flex-between">
                        <lp-check-bool :checkedVal.sync="item.enable" @onCheck="res => onCheck(item, res)"
                                       :key="`pay-type-${idx}`"
                                       :label="item.label"></lp-check-bool>
                        <button
                          class="button" style="width:176px" @click="clickInfo(item)">{{ item.label }} 계약 안내</button>
                      </div>
                      <lp-add-pay-type v-else :key="`pay-type-${idx}`"
                                       :label="item.label" :item="item"></lp-add-pay-type>
                      <div v-if="item.name==='kakaopay' && value" style="margin-top:8px">
                        <div v-if="item.enable">

                          <div style="background-color:#E9E9E9;padding:12px 9px">
                            <admin-form-item label="카카오페이 계정 정보 입력"
                                             tip="결제기능 연동을 위해서는 카카오페이와의 계약이 필요합니다.">
                              <div style="padding-top:8px">
                                <input class="input"
                                       :value="value.social_key.kakao.cid"
                                       @input="e=> value.social_key.kakao.cid = e.target.value"
                                       placeholder="KaKaoPay cid"
                                       type="text" maxlength="50">
                                <div class="desc">가맹점 코드. 10자</div>
                                <input class="input"
                                       style="margin-top:12px"
                                       :value="value.social_key.kakao.admin_key"
                                       @input="e=> value.social_key.kakao.admin_key = e.target.value"
                                       placeholder="Admin 키"
                                       type="text" maxlength="50">
                                <div class="desc">[Kakao Developers] 설정 > 일반 > 기본정보 > 앱 키에서 Admin 키를 복사해서 붙여 넣어주세요.</div>

                              </div>
                            </admin-form-item>
                          </div>
                        </div>
                      </div>
                      <div v-if="item.name==='naverpay' && value" style="margin-top:8px">
                        <div v-if="item.enable">

                          <div style="background-color:#E9E9E9;padding:12px 9px">
                            <admin-form-item label="네이버페이 계정 정보 입력"
                                             tip="결제기능 연동을 위해서는 네이버페이와의 계약이 필요합니다.">
                              <div style="padding-top:8px">
                                <admin-form-item label="파트너 ID">
                                  <input class="input"
                                        :value="value.social_key.naver.partner_id"
                                        @input="e=> value.social_key.naver.partner_id = e.target.value"
                                        placeholder="네이버페이 파트너 ID"
                                        type="text" maxlength="50">
                                </admin-form-item>
                                <admin-form-item label="Client ID">
                                  <input class="input"
                                        :value="value.social_key.naver.pay.client_id"
                                        @input="e=> value.social_key.naver.pay.client_id = e.target.value"
                                        placeholder="네이버페이 Client ID"
                                        type="text" maxlength="50">
                                </admin-form-item>
                                <admin-form-item label="Client Secret">
                                  <input class="input"
                                        :value="value.social_key.naver.pay.client_secret"
                                        @input="e=> value.social_key.naver.pay.client_secret = e.target.value"
                                        placeholder="네이버페이 Client Secret"
                                        type="text" maxlength="50">
                                </admin-form-item>
                              </div>
                            </admin-form-item>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--<div v-if="pay.name==='inicis' && value && enablePg" style="margin-top:16px">
                    <div style="background-color:#E9E9E9;padding:12px 9px">
                      <admin-form-item label="KG 이니시스 계정 정보 입력"
                                       tip="결제기능 연동을 위해서는 PG사(KG 이니시스)와의 계약이 필요합니다.
                                      위의 ‘PG 계약하기’ 단추를 클릭하면 이니시스 계약 진행 페이지로 바로 이동합니다."
                                       primaryTip="*결제 기능 각각 별도의 계약이 필요하며, 호스팅사는 런치팩으로 입력해주시기 바랍니다.">
                        <button slot="title" @click="clickBtn(pay.name)" class="button text-primary" style="width: auto; margin-bottom: 0.5em">PG 계약하기</button>
                        <div style="padding-top:8px">
                          <input class="input"
                                 :value="value.social_key.inicis.mid"
                                 @input="e => value.social_key.inicis.mid = e.target.value"
                                 type="text" maxlength="50">
                          <div class="desc">KG이니시스 어드민사이트의 상단 메뉴 상점정보>계약정보>기본정보 화면의 상점 ID를 입력하세요.</div>
                          <input class="input"
                                 style="margin-top:6px"
                                 :value="value.social_key.inicis.sign_key"
                                 @input="e => value.social_key.inicis.sign_key = e.target.value"
                                 type="text" maxlength="50">
                          <div class="desc">KG이니시스 어드민사이트의 상단 메뉴 상점정보>계약정보>부가정보 화면의 웹 결제 SignKey를 입력하세요.</div>

                        </div>
                      </admin-form-item>


                    </div>
                  </div>-->
                </admin-form-item>
              </template>
              <div v-if="!isCall && serviceInfo.plan && serviceInfo.plan.trial"
                   class="plan-wrapper">
                <button class="button is-primary" @click="clickPlan">{{ serviceInfo.service_type === 5 ? '스킨' : '플랜' }} 결제</button>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>

    </div>

    <pay-price-modal v-if="showPayPriceModal" @cancel="showPayPriceModal=false"></pay-price-modal>

    <modal name="paySuccessModal" :adaptive="true" :width="600" height="auto" class="modal-style" :clickToClose="false">
      <div class="lp-modal-wrapper" style="background-color:#E9E9E9" v-if="result">
        <div style="font-weight:600;font-size:20px;color:#000000">PG 신청 완료</div>
        <div style="padding:45px 108px;border-radius:6px;background-color:white;margin-top:23px;text-align:center">
          <div style="font-size:21px">{{ result.goodsName }} 기능 신청이 완료되었습니다.</div>
          <div style="margin-top:9px;font-size: 13px">1~2일 내, 메일로 연동 과정에 대한 안내 드리도록 하겠습니다.</div>
          <div class="flex-center" style="margin-top:49px">
            <div>
              <div class="flex-align">
                <div style="font-size:13px;font-weight:600">결제상품</div>
                <div style="font-size:13px;margin-left:69px">{{ result.goodsName }}</div>
              </div>
              <div class="flex-align" style="margin-top:9px">
                <div style="font-size:13px;font-weight:600">결제금액</div>
                <div style="font-size:13px;margin-left:69px">{{ result.TotPrice | currency }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-group-justify-end" style="margin-top:61px;margin-bottom:16px">
          <button class="button is-primary" @click="$modal.hide('paySuccessModal')">확인</button>
        </div>
      </div>
    </modal>

    <modal name="VBankModal" :adaptive="true" :width="600" height="auto" class="modal-style" :clickToClose="false">
      <div class="lp-modal-wrapper" style="background-color:#E9E9E9" v-if="result">
        <div style="font-weight:600;font-size:20px;color:#000000">무통장 입금 안내</div>
        <div style="padding:45px 108px;border-radius:6px;background-color:white;margin-top:23px;text-align:center">
          <div> {{ datesFormat(result.VACT_Date, 'date_4') }} 까지 은행에 입금해 주셔야<br> 결제가 완료됩니다.</div>
          <div class="flex-center" style="margin-top:49px">
            <div>
              <div class="flex-align">
                <div style="width:51px;font-size:13px;font-weight:600">입금 은행</div>
                <div style="font-size:13px;margin-left:69px">{{ result.vactBankName }}</div>
              </div>
              <div class="flex-align" style="margin-top:9px">
                <div style="width:51px;font-size:13px;font-weight:600">예금주</div>
                <div style="font-size:13px;margin-left:69px">{{ result.VACT_Name }}</div>
              </div>
              <div class="flex-align" style="margin-top:9px">
                <div style="width:51px;font-size:13px;font-weight:600">입금 금액</div>
                <div style="font-size:13px;margin-left:69px">{{ result.TotPrice | currency}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-group-justify-end" style="margin-top:61px;margin-bottom:16px">
          <button class="button is-primary" @click="$modal.hide('VBankModal')">확인</button>
        </div>
      </div>
    </modal>

    <modal name="infoModal" :adaptive="true" :width="800" height="auto" class="modal-style" :clickToClose="true">
      <div class="position-relative" v-if="selectedItem" style="height:90vh">
        <div :style="`padding:28px 32px;${selectedItem.label === '신용카드' ? 'height: calc(90vh - 80px);overflow: auto;' : ''}`">
          <div class="flex-between" style="margin-bottom:32px">
            <div class="size-20 weight-700">{{ selectedItem.label }} 계약 안내</div>
            <i class="material-icons unselect" @click="$modal.hide('infoModal')">close</i>
          </div>
          <div v-html="info"></div>
        </div>
        <div v-if="selectedItem.label === '신용카드'" class="position-absolute flex-center"
             style="width:100%;left:0;bottom:0;background-color: white;padding: 16px 0">
          <button class="button is-primary button-contract" @click="clickInquiryCredit">계약 신청하러 가기</button>
        </div>
      </div>
    </modal>

    <modal name="confirmModal" adaptive :width="600" :height="190" class="modal-style" clickToClose>
      <i class="material-icons unselect" style="position: absolute;top:28px;right:32px"
         @click="$modal.hide('confirmModal')">close</i>
      <div v-if="selectedItem" class="text-center" style="padding:28px 32px">
        <div class="size-20 weight-700">{{ selectedItem.label }} 계약이 완료되었나요?</div>
        <div class="size-14" style="margin:12px 0 32px 0">{{ selectedItem.label }} 결제 방식을 이용하기 위해서는 {{ selectedItem.company }} 별도 계약이 필요합니다.</div>
        <div class="flex-center" style="gap:12px">
          <button class="button is-grey-light" style="width:200px" @click="clickConfirmNo">아니요, 계약 안내 보기</button>
          <button class="button" style="width:200px" @click="clickConfirmYes">네, 계약이 완료되었습니다.</button>
        </div>
      </div>
    </modal>

    <!-- 저장하기 버튼 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="save">저장하기</button>
    </div>
  </div>
</template>

<script>
  import LpRadio from "../../module/common/LpRadio";
  import OrderSetting from "./components/OrderSetting";
  import LpCheckBool from "../../module/common/LpCheckBool";
  import LpAddPayType from "../../module/common/LpAddPayType";
  import PayPriceModal from "./components/PayPriceModal";

  export default {
    layout: 'Main',
    name: 'ServiceSetting',
    components: {
      PayPriceModal,
      LpCheckBool,
      LpAddPayType,
      OrderSetting,
      LpRadio
    },
    created() {
      this.getPackages();
      this.$axios.get('public/banks').then(res => {
        this.bankArr = res.data;
      });
      // OrderSetting 호출 (기본 결제방식, 무통장입금 은행)
      this.$axios.get(this.getUrl('v1/order/setting')).then(res => {
        res.data.paylist.forEach(pay => {
          pay.pay_type.forEach(type => {
            // 결제 방식 사용여부 기본 값 세팅
            if (type.name === 'credit' || type.name === 'nobank') {
              type.isUsable = true;
            } else {
              // 플러그인 사용 여부에 따라 결제 방식 사용여부 값 설정
              if (this.useOrderPlugin(type.name)) {
                type.isUsable = true;
              } else {
                type.isUsable = false;
              }
            }
          })
        })
        this.orderSetting = res.data;
      });

      // PackageSetting 호출 (상품종류 별 주문전환,문의전환,결제방식,자동처리 설정)
      this.$axios.get('admin/service/package_setting/init').then(() => {
        this.$axios.get('admin/service/package_setting?ordering=order_conversion_type').then(res => {
          res.data.forEach(item => {
            item.kor_name = this.packages.filter(pack => {
              return pack.name === item.package
            })[0].kor_name;
          });
          this.packageSettings = res.data;
        });
      });

      // 기본 상품 종류 불러오기
      this.$axios.get('admin/service/setting')
        .then(res => {
          if (res.status === 200) {
            this.basic_package = res.data.basic_package;
            if(this.basic_package!=='') {
              this.selectPackage(find(this.packages, 'name', this.basic_package));
            } else if(this.packages.length>0) {
              this.selectPackage(this.packages[0]);
            }
          }
        });

      this.$axios.get('admin/service/social_key')
        .then(res => {
          if (res.status === 200) {
            this.value = res.data
          }
        });

      window.addEventListener('message', e => {
        // console.log(e.data);
        if (!e.data) return;
        if (e.data.result === 'close') {
          this.showPayPriceModal = false;
        }
      });
    },
    mounted() {
      if (this.$route.query.result) {
        this.result = JSON.parse(this.$route.query.result)
        if (this.result.payMethod === 'VBank') {
          this.$axios.post('public/pg_vbank/create', {
            result: this.result,
            merchant_id: this.$store.getters.payPriceMerchantId
          }).then(res => {
            if (res.status === 200) {
              this.$modal.show('VBankModal');
              this.$router.replace(this.$route.path);
            }
          })
        } else this.pay();
      }
    },
    data() {
      return {
        info: '',
        selectedItem: undefined,
        basic_package: '',
        bankArr: [],
        orderSetting: {
          'pay_type': [],
          'bank': {
            'name': '',
            'bank': '',
            'account_num': ''
          },
          'paylist': [
            {
              'name': 'basic',
              'label': '기본',
              'pay_type': [
                {
                  'name': 'nobank',
                  'label': '무통장입금',
                  "enable": false,
                  "value": 2
                }
              ]
            },
            {
              'name': 'inicis',
              'label': "일반 PG 결제",
              'pay_type': [
                {
                  'name': 'credit',
                  'label': '신용카드',
                  "enable": false,
                  "value": 0
                },
                {
                  'name': 'trans',
                  'label': '실시간 계좌이체',
                  "enable": false,
                  "value": 3
                },
                {
                  'name': 'vbank',
                  'label': '가상계좌',
                  "enable": false,
                  "value": 4
                }
              ]
            },
            {
              'name': 'simple',
              'label': '간편결제',
              'pay_type': [
                {
                  'name': 'kakaopay',
                  'label': '카카오 페이',
                  "enable": false,
                  "value": 5
                },
                {
                  "name": "naverpay",
                  "label": "네이버 페이",
                  "enable": false,
                  "value": 6
                }
              ]
            }
          ]
        },
        selectedPackage: '',
        packages: [],
        value: undefined,
        showPayPriceModal: false,
        result: {
          "mid": "launchpack",
          "tid": "StdpayVBNKlaunchpack20210823174244552825",
          "MOID": "launchpack_1629708140894",
          "p_Sub": "",
          "TotPrice": "1000",
          "VACT_Num": "56211105325513",
          "applDate": "20210823",
          "applTime": "174244",
          "buyerTel": "01038208216",
          "currency": "WON",
          "goodName": "카카오페이",
          "p_SubCnt": "",
          "EventCode": "",
          "VACT_Date": "20210922",
          "VACT_Name": "런치팩（주）",
          "VACT_Time": "235959",
          "buyerName": "김준호",
          "custEmail": "jhkim@launchpack.co.kr",
          "goodsName": "카카오페이",
          "payDevice": "PC",
          "payMethod": "VBank",
          "resultMsg": "정상처리되었습니다.",
          "buyerEmail": "jhkim@launchpack.co.kr",
          "resultCode": "0000",
          "parentEmail": "",
          "vactBankName": "신한(통합)은행",
          "VACT_BankCode": "88",
          "authSignature": "8e735a2436633e952a469e95a0b9ce79d185ba57927df92c0fae18c33acabbb1",
          "FlgNotiSendChk": "",
          "VACT_InputName": "김준호"
        }
      }
    },
    computed: {
      enablePg() {
        let item = this.orderSetting.paylist.find(i => i.name === 'inicis');
        return item.pay_type.some(i => i.enable);
      },
      basicPay() {
        return this.orderSetting.paylist.find(i => i.name === 'basic');
      },
      payList() {
        return this.orderSetting.paylist.filter(i => i.name !== 'basic');
      },
      isCall() {
        return this.packages.length === 0 || (this.packages.length === 1 && this.packages[0].name === 'call');
      },
      showPayTypeSetting() {
        return [0, 1, 2, 4, 5, 6, 7, 9].indexOf(this.selectedPackage.order_conversion_type) === -1;
      }
    },
    methods: {
      clickInquiryCredit() {
        this.$modal.hide('infoModal');
        this.routerPush('/office/admin/launchpack/inquiry/customer/create?cat=18');
      },
      clickConfirmNo() {
        this.$modal.hide('confirmModal');
        this.clickInfo(this.selectedItem);
      },
      clickConfirmYes() {
        this.$modal.hide('confirmModal');
        this.selectedItem.contract = true;
      },
      onCheck(item, res) {
        if(res && !item.contract) {
          this.selectedItem = item;
          this.$modal.show('confirmModal');
        }
      },
      clickInfo(item) {
        this.selectedItem = item;
        let id = {
          '신용카드': 220,
          '실시간 계좌이체': 154,
          '가상계좌': 175,
          '카카오 페이': 151,
          '네이버 페이': 150
        }[item.label];
        this.info = '';
        this.$axios.get(`https://master-dev.launchpack.co.kr:1111/public/launchpack/v1/theme/${id}`).then(res => {
          this.info = res.data.info;
        });
        this.$modal.show('infoModal');
      },
      clickPlan() {
        this.$root.$emit('planChangeModal');
      },
      // 플러그인 사용여부 확인
      useOrderPlugin(pay_type_name) {
        return {
          trans: this.isInternalPlugin('account_transfer'),
          phone: this.isInternalPlugin('mobile_payment'),
          vbank: this.isInternalPlugin('virtual_account'),
          kakaopay: this.isInternalPlugin('kakaopay'),
          naverpay: this.isInternalPlugin('naverpay')
        }[pay_type_name]
      },
      // 상품 종류 선택하기
      selectPackage(pack) {
        this.basic_package = pack.name;
      },
      getPackages() {
        this.packages = this.$store.getters.getPackages;
      },
      async save() {
        let enable = true;
        // 무통장입금 사용시, 계좌번호와 예금주가 입력되어있는지 확인
        if (this.orderSetting.paylist[0].pay_type[0].name === 'nobank' && this.orderSetting.paylist[0].pay_type[0].enable) {
          if (this.orderSetting.bank.account_num === '' && this.orderSetting.bank.name === '') {
            this.toast('입금 은행과 계좌번호를 설정해주세요.');
            enable = false;
          }
        }
        // 일반 PG 결제 체크, 계정 정보 입력 여부 확인
        /*if(this.orderSetting.paylist[1].pay_type.some(i => i.enable)) {
          if(this.value.social_key.inicis.mid.trim() === '' ||
            this.value.social_key.inicis.sign_key.trim() === '') {
            this.toast('KG 이니시스 계정 정보를 입력해주세요.');
            enable = false;
          }
        }*/

        let kakao = this.orderSetting.paylist[2].pay_type.find(i => i.name === 'kakaopay');
        if(kakao && kakao.enable) {
          if(!this.value.social_key.kakao.cid ||
            this.value.social_key.kakao.cid.trim() === '' ||
            !this.value.social_key.kakao.admin_key ||
            this.value.social_key.kakao.admin_key.trim() === '' ) {
            this.toast('카카오 페이 계정 정보를 입력해주세요.');
            enable = false;
          }
        }

        let naver = this.orderSetting.paylist[2].pay_type.find(i => i.name === 'naverpay');
        if(naver && naver.enable) {
          if(!this.value.social_key.naver.client_id ||
            this.value.social_key.naver.client_id.trim() === '' ||
            !this.value.social_key.naver.client_secret ||
            this.value.social_key.naver.client_secret.trim() === '' ) {
            this.toast('네이버 페이 계정 정보를 입력해주세요.');
            enable = false;
          }
        }

        if (enable) {
          // 기본 상품 종류 업데이트
          await this.$axios.patch('admin/service/setting', {basic_package: this.basic_package});
          // 기본 설정 업데이트
          await this.$axios.patch('admin/order/setting', {value: this.orderSetting});
          await this.$axios.post('admin/service/social_key', this.value);
          this.$store.commit('setBackendData', {social_key: this.value.social_key});
          this.toast('서비스 설정이 저장되었습니다.');
          this.saveServiceGuide('pay')
        }
      },
      addPayType() {
        this.showPayPriceModal = true;
      },
      pay() {
        if (this.result.resultCode && this.result.resultCode !== '0000') {
          if (this.result.resultMsg) this.toast(this.result.resultMsg);
          else this.toast('결제가 정상적으로 이루어지지 않았습니다. 다시 결제해주세요.')
          this.$router.replace(this.$route.path);
          return;
        }
        this.$axios.post('public/pg_shop/create', {
          result: this.result,
          merchant_id: this.$store.getters.payPriceMerchantId
        }).then(res => {
          if (res.status === 200) {
            this.$modal.show('paySuccessModal');
            this.$axios.get(this.getUrl('order/setting')).then(res => {
              this.orderSetting = res.data;
            });
            this.$router.replace(this.$route.path);
          }
        }).catch(error => {
          if (error.response && error.response.data.message) {
            this.toast(error.response.data.message);
            this.$router.replace(this.$route.path);
          } else this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.');
        })
      },
      clickBtn(pay_name) {
        if (pay_name === 'inicis') {
          const a = document.createElement('a');
          a.href = 'https://www.inicis.com/service-application?settlement=N&cd=hostinglanding&product=launchpack';
          a.target = '_blank';
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
          a.parentNode.removeChild(a);
        } else if(pay_name === 'naverpay') {
          this.$root.$emit('appMarket', {plugin: 'naverpay'})

        }
        else {
          this.$root.$emit('appMarket', {plugin: 'kakaopay'})
        }
      }
    },
    watch: {
      '$store.getters.orderSetting'(n) {
        n.paylist.forEach(pay => {
          pay.pay_type.forEach(type => {
            // 결제 방식 사용여부 기본 값 세팅
            if (type.name === 'credit' || type.name === 'nobank') {
              type.isUsable = true;
            } else {
              // 플러그인 사용 여부에 따라 결제 방식 사용여부 값 설정
              if (this.useOrderPlugin(type.name)) {
                type.isUsable = true;
              } else {
                type.isUsable = false;
              }
            }
          })
        })
        this.orderSetting = n;
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'
  .pack-box
    border 1px solid #787878
    color #787878
    display inline-block
    padding 4px 16px
    border-radius 3px
    margin 4px
    font-size 14px
    cursor pointer

  .package-selected
    color $primary
    border 1px solid $primary

  .desc
    font-size 0.8rem
    margin-top 4px
    color #787878

  .dim
    background-color rgba(0,0,0,0.6)
    position absolute
    width 100%
    height 100%
    border-radius 4px
    top 0
    left 0
    text-align right
    padding 16px 48px 0 0
    z-index 2
    font-size 15px
    color white

  .plan-wrapper
    position absolute
    width calc(100% + 2.5rem)
    height calc(100% + 2.4rem)
    border-bottom-left-radius 4px
    border-bottom-right-radius 4px
    z-index 1
    top -8px
    left -1.25rem
    background-color rgba(0,0,0,0.3)
    display flex
    align-items center
    justify-content center
    .button
      width 87px
      height 36px

  .button-contract
    width 200px
    font-size 16px !important
    height 48px !important
    font-weight 700
</style>
